import { Injectable } from '@angular/core';
import { TOAST } from '../models/toast';
import { NotificationType } from '../enums/notificationType';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  public toasts: TOAST[] = [];

  public show(type: string, message: string, duration = 5000): void {
    const toast = { type, message };
    this.toasts.push(toast);
    setTimeout(() => {
      this.remove(toast);
    }, duration);
  }

  private remove(toast: TOAST): void {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  public showSuccess(message: string, duration = 5000): void {
    this.show(NotificationType.Success, message, duration);
  }

  public showInfo(message: string, duration = 5000): void {
    this.show(NotificationType.Info, message, duration);
  }

  public showError(message: string, duration = 5000): void {
    this.show(NotificationType.Danger, message, duration);
  }
}
